module.exports = __webpack_public_path__ + "img/logo.6b06c7db.png";